tr(:data-test='`bids-${index}`')
  td(:title='bid.date.toHuman()')
    RelativeTimeVue(:date='bid.date.date')
  td
    .fp-horizontal-spacing.-items-center.-s-md
      .fp-horizontal-spacing--column
        .fp-image.-rounded
          ExclusiveImageVue(:url='bid.exclusive.imageUrl')
      .fp-horizontal-spacing--column {{ bid.exclusive.name }}
  td
    .fp-horizontal-spacing.-items-center.-s-md
      .fp-horizontal-spacing--column
        .fp-image.-circled
          FanImageVue(:url='bid.bidder.pictureUrl')
      .fp-horizontal-spacing--column {{ bid.bidder.firstName }} {{ bid.bidder.lastName }}
  td {{ bid.price.totalCost.text }}
